import { css, Theme, Interpolation } from '@emotion/react'

export const wrapper: Interpolation<Theme> = css`
  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const emptyText: Interpolation<Theme> = (theme) => css`
  color: ${theme.typographyColors.typographyThree};
  text-align: center;
`

export const scrollable: Interpolation<Theme> = css`
  overflow-x: auto;
`

export const content: Interpolation<Theme> = css`
  width: auto;
`
